
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/netzwerk/ueber-uns",
      function () {
        return require("private-next-pages/netzwerk/ueber-uns/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/netzwerk/ueber-uns"])
      });
    }
  